/* Balanz: newsletter navigation and existing marquee presentation. */
(() => {
  'use strict';
  const SELECTORS = { marqueeTrack: '.balanz-marquee__track' };

  function focusTarget(target) {
    const focusable = target.querySelector('input[type="email"]')
      || target.querySelector('[data-balanz-signup-feedback]') || target;
    focusable.focus({ preventScroll: true });
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      block: 'start'
    });
  }

  // Only intercept the signup anchor; configured external links keep their behavior.
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href="#BalanzEmailSignup"]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const target = document.getElementById('BalanzEmailSignup');
    if (!target) return;
    event.preventDefault();
    focusTarget(target);
  });

  function focusFeedback(root) {
    const feedback = root.querySelector('[data-balanz-signup-feedback]');
    if (feedback && !window.Shopify?.designMode) feedback.focus({ preventScroll: false });
  }

  function repairMarquee(track) {
  if (!track || track.closest('.balanz-02-marquee-v2')) return;

  const itemHTML = '<span>RECIBES · PREPARAS · EMPIEZA ALGO BUENO</span>';

  track.innerHTML = '';

  for (let i = 0; i < 12; i += 1) {
    track.insertAdjacentHTML('beforeend', itemHTML);
  }

  track.dataset.balanzV12Repaired = 'true';
}

  function repairAllMarquees() {
    document.querySelectorAll(SELECTORS.marqueeTrack).forEach(repairMarquee);
  }


  function boot() {
    focusFeedback(document);
    repairAllMarquees();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll(SELECTORS.marqueeTrack).forEach(repairMarquee);
  });
})();
